import React from 'react';
import PropTypes from 'prop-types';
import Menu from '@material-ui/core/Menu';
import classNames from 'classnames';
import ContextMenuOption from './ContextMenuOption';

const NestedMenu = ({
  classes, config, open, handleClose, anchorElement, selection, setMouseOver, mouseOver, test,
}) => {
  const pointEventsStatus = mouseOver ? 'auto' : 'none';

  return (
    <Menu
      style={{ pointerEvents: pointEventsStatus }}
      open={open}
      anchorEl={anchorElement}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      <div
        className={classNames(classes.nestedRoot)}
        test={test}
        onMouseEnter={(e) => setMouseOver(true, e)}
        onMouseLeave={(e) => setMouseOver(false, e)}
      >
        {config.options.map(option => <ContextMenuOption selection={selection} classes={classes} option={option} test={option.test} handleClose={handleClose} />)}
      </div>
    </Menu>
  );
};

NestedMenu.defaultProps = {
  open: false,
  handleClose: () => {},
  anchorElement: null,
  selection: '',
  test: '',
  setMouseOver: () => {},
  mouseOver: false,
};

NestedMenu.propTypes = {
  classes: PropTypes.arrayOf(PropTypes.string).isRequired,
  config: PropTypes.shape({
    options: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func,
    })),
  }).isRequired,
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  anchorElement: PropTypes.object,
  selection: PropTypes.string,
  test: PropTypes.string,
  setMouseOver: PropTypes.func,
  mouseOver: PropTypes.bool,
};

export default NestedMenu;
